import {FC, useContext, useState} from "react";
import LanguageButton from "../atoms/LanguageButton.tsx";
import AppBar from "../molecules/AppBar.tsx";
import LanguageSelectMenu from "../molecules/LanguageSelectMenu.tsx";
import {LanguageContext} from "../store/languageContext.ts";

interface Props {
    title?: string;
}

const AppBarWithLanguageSelect: FC<Props> = ({ title }) => {
    const languageContext = useContext(LanguageContext);
    const [open, setOpen] = useState(false);

    return <AppBar title={title}>
        <LanguageButton language={languageContext.language} onClick={() => setOpen(true)} />
        <LanguageSelectMenu value={languageContext.language.languageCode} onChange={(lc) => {
            languageContext.setLanguage(lc)
            setOpen(false)
        }} open={open}/>
    </AppBar>
}

export default AppBarWithLanguageSelect